import { components } from '../../../api/simple-project-service/project-service.generated.v3';
import {
  simpleProjectServicePublicUrl,
  simpleProjectServiceUrl,
} from '../../../config/environment';
import { useApp } from '../../../hooks/useApp';
import { useAsync } from '../../../hooks/useAsync';
import { callApi } from '../../../utils/callApi';

export type ConfigurationData = components['schemas']['ConfigurationDataDto'];

export const useConfigurationApi = () => {
  const { loggedIn } = useApp();
  const {
    start: getConfigurationDataById,
    result: configurationDataById,
    error: configurationDataByIdError,
  } = useAsync(getConfiguration(loggedIn));

  return {
    getConfigurationDataById,
    configurationDataById,
    configurationDataByIdError,
  };
};

const getConfiguration = (loggedIn: boolean) => async (id: string): Promise<ConfigurationData> => {
  const url = `${
    loggedIn ? simpleProjectServiceUrl : simpleProjectServicePublicUrl
  }/api/v3/configurations/${id}`;
  const { data } = await callApi<ConfigurationData>(url, 'GET');
  return data;
};
